import React from 'react'

export default function Assets() {
    return (
        <section id="assets" class="mt-5">
            <h3 class="text-xl font-semibold mb-3">📘 Assets & Script Helpers Documentation</h3>
            <p>This section explains how to include external scripts, styles, inline scripts, and inline CSS using the custom Handlebars helpers integrated in the project.
            </p>

            <h5 class="text-lg font-semibold mt-4">1. Add External JavaScript — <code>{`{{{script}}}`}</code></h5>
           <p>Use this helper when you want to load a JavaScript file from a CDN or any external source.</p>
<h5><strong>Example</strong></h5>
<pre class="overflow-visible!"><div class="contain-inline-size rounded-2xl relative bg-token-sidebar-surface-primary"><div class="overflow-y-auto" dir="ltr"><code class="whitespace-pre! language-hbs"><span>{`{{{script "https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.9.0/slick.min.js"}}}`}
</span></code></div></div></pre>
<h5><strong>Generated Output</strong></h5>
<pre class="overflow-visible!"><div class="contain-inline-size rounded-2xl relative bg-token-sidebar-surface-primary"><div class="overflow-y-auto" dir="ltr"><code class="whitespace-pre! language-html"><span><span><span class="hljs-tag">&lt;<span class="hljs-name">script</span></span></span><span> </span><span><span class="hljs-attr">data-external-script</span></span><span>=</span><span><span class="hljs-string">"https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.9.0/slick.min.js"</span></span><span>&gt;</span><span><span class="hljs-tag">&lt;/<span class="hljs-name">script</span></span></span><span>&gt;
</span></span></code></div></div></pre>
<p>Your React <code>TemplateRenderer</code> will detect this and inject it dynamically.</p>
<hr />
<h4><strong>2. Add External CSS — <code>{`{{{style}}}`}</code></strong></h4>
<p>Use this helper to include external CSS files.</p>
<h5><strong>Example</strong></h5>
<pre class="overflow-visible!"><div class="contain-inline-size rounded-2xl relative bg-token-sidebar-surface-primary"><div class="overflow-y-auto" dir="ltr"><code class="whitespace-pre! language-hbs"><span>{`{{{style "https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.9.0/slick.min.css"}}}`}
</span></code></div></div></pre>
<h5><strong>Generated Output</strong></h5>
<pre class="overflow-visible!"><div class="contain-inline-size rounded-2xl relative bg-token-sidebar-surface-primary"><div class="overflow-y-auto" dir="ltr"><code class="whitespace-pre! language-html"><span><span><span class="hljs-tag">&lt;<span class="hljs-name">link</span></span></span><span> </span><span><span class="hljs-attr">rel</span></span><span>=</span><span><span class="hljs-string">"stylesheet"</span></span><span> </span><span><span class="hljs-attr">href</span></span><span>=</span><span><span class="hljs-string">"https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.9.0/slick.min.css"</span></span><span> /&gt;
</span></span></code></div></div></pre>
<p>This will be moved to the <code>&lt;head&gt;</code> automatically.</p>
<hr />
<h4><strong>3. Add Inline JavaScript — <code>{`{{{inlineScript}}}`}</code></strong></h4>
<p>This helper embeds raw JavaScript code inside the template.</p>
<h5><strong>Example</strong></h5>
<pre class="overflow-visible!"><div class="contain-inline-size rounded-2xl relative bg-token-sidebar-surface-primary"><div class="overflow-y-auto" dir="ltr"><code class="whitespace-pre! language-hbs"><span>{`{{{inlineScript "(function() {
  $(document).ready(function () {
      console.log('Slider Ready');
  });
})();"}}}`}
</span></code></div></div></pre>
<p>The script will be executed sequentially by your <code>TemplateRenderer</code>.</p>
<hr />
<h4><strong>4. Add Inline CSS — <code>{`{{{inlineStyle}}}`}</code></strong></h4>
<p>Use this for custom styling inside the template.</p>
<h5><strong>Example</strong></h5>
<pre class="overflow-visible!"><div class="contain-inline-size rounded-2xl relative bg-token-sidebar-surface-primary"><div class="overflow-y-auto" dir="ltr"><code class="whitespace-pre! language-hbs"><span>{`{{{inlineStyle "
  * {
      box-sizing: border-box;
  }
"}}}`}
</span></code></div></div></pre>
<p>Note: Your renderer automatically moves it into <code>&lt;head&gt;</code>.</p>

        </section>

    )
}